import React, { useCallback, useEffect, useState } from "react";
import s from './MyButton.module.css';

import whiteLoadingPng from'../asset/white-loading.png';

export function RedButton({isEnabled = true, clickedAction, bText, myRef, isLoading, overrideStyle}) {	
	return (<div ref={myRef} className={(isEnabled) ? s.redEnabled : s.disabled} style={overrideStyle}
		onClick={clickedAction}>
			<div style={{visibility:(isLoading?"hidden":"visible")}}>{bText}</div>
			<div style={{visibility:(isLoading?"visible":"hidden")}} className={s.loadingImgHolder}>
				<img className={s.loadingImg} src={whiteLoadingPng}/>
			</div>
	</div>)
}
export function GreenButton({isEnabled = true, clickedAction, bText, myRef, isLoading, overrideStyle}) {	
	return (<div ref={myRef} className={(isEnabled) ? s.greenEnabled : s.disabled} style={overrideStyle}
		onClick={clickedAction}>
			<div style={{visibility:(isLoading?"hidden":"visible")}}>{bText}</div>
			<div style={{visibility:(isLoading?"visible":"hidden")}} className={s.loadingImgHolder}>
				<img className={s.loadingImg} src={whiteLoadingPng}/>
			</div>
	</div>)
}

export function BlueButton({isEnabled = true, clickedAction, bText, myRef, isLoading, overrideStyle}) {	
	return (<div ref={myRef} className={(isEnabled) ? s.blueEnabled : s.disabled} style={overrideStyle}
		onClick={clickedAction}>
			<div style={{visibility:(isLoading?"hidden":"visible")}}>{bText}</div>
			<div style={{visibility:(isLoading?"visible":"hidden")}} className={s.loadingImgHolder}>
				<img className={s.loadingImg} src={whiteLoadingPng}/>
			</div>
	</div>)
}